import {combineReducers } from 'redux';
import recordReducer from './recordReducer';
import ajaxReducer from './ajaxReducer';
import uxReducer from './uxReducer';
import userReducer from "./userReducer";
import locateReducer from '../../components/Locate/reducer'
import recordCReducer from '../../components/Record/reducer';
import metaReducer from '../../shared/reducers/metaReducer';

const rootReducer = combineReducers({
    record: recordReducer,
    ajax: ajaxReducer,
    ux: uxReducer,
    meta: metaReducer,
    user: userReducer,
    components: combineReducers({
        locate: locateReducer,
        record: recordCReducer
    })
});

export default rootReducer;